import type { ConfigIdFields } from '../types'

export function decodeConfigId(id: string): ConfigIdFields {
  const obj = JSON.parse(atob(id)) as Record<string, string>
  return {
    configKey: obj.configKey,
    tenantCode: obj.tenantCode ?? null,
    inventorySystemProfileCode: obj.inventorySystemProfileCode ?? null,
    venueId: obj.venueId ?? null,
  }
}
